import {
    authConstants
  } from "./../constants/auth-constants";
  

  const initialState = {
    paymentList: []
  };
  function paymentMethodReducer(state  = initialState, action) {
    switch (action.type) {
      case authConstants.PAYMENT_METHOD_LIST:
        return {
            ...state,
            paymentList: action.payload.data
          };

      default:
        return state ;
    }
  };
  
  export default paymentMethodReducer;